import log from 'salvo-lite/log'

class Meganav {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._menuTriggers = document.querySelectorAll('.custom-nav--has-dropdown')
        this._menuItems = document.querySelectorAll('.custom-nav__dropdown-wrapper')
        this._dropdownIsActive = false
        this._animating = false
        this._megaNavImage = document.querySelector('[data-meganav-image]')
        this._megaNavTopImage = document.querySelector('.top-image')
        this._megaNavBackgroundImage = document.querySelector('.background-image')
        this._menuItemsWithImages = document.querySelectorAll('[data-collection-image]')
        this._menuItemsWithoutImages = document.querySelectorAll('.custom-nav__deep-dropdown-trigger:not([data-collection-image])')
        this._menuItemOverlays = document.querySelectorAll('.meganav-overlay')
    }

    onInit () {
        log.debug(this.constructor.name, 'initialised', this)

        this._menuTriggers.forEach((menuTrigger) => {
            menuTrigger.addEventListener('transitionstart', (e) => {
                if (e.propertyName === 'transform') {
                    this._animating = true
                }
            })

            menuTrigger.addEventListener('transitionend', (e) => {
                if (e.propertyName === 'transform') {
                    this._animating = false
                }
            })

            menuTrigger.addEventListener('mouseenter', () => {
                let menuItem = menuTrigger.querySelector('.custom-nav__dropdown-wrapper')
                // if menu not already open...
                if (!menuItem.classList.contains('active') && !this._animating) {
                    // open the meganav item.
                    menuItem.classList.add('active')
                    console.log('step 1...')
                }
            })

            menuTrigger.addEventListener('click', (e) => {
                e.preventDefault()
                let menuItem = menuTrigger.querySelector('.custom-nav__dropdown-wrapper')
                // if menu not already open...
                if (!menuItem.classList.contains('active') && !this._animating) {
                    // open the meganav item.
                    menuItem.classList.add('active')
                    console.log('step 1...')
                }
            })

            menuTrigger.addEventListener('mouseleave', (e) => {
                let menuItem = menuTrigger.querySelector('.custom-nav__dropdown-wrapper')
                // if menu not already open...

                let check = () => {
                    if (this._dropdownIsActive) {
                        console.log('keep menu open!')
                    } else {
                        console.log('close the menu!')
                        this._closeMenuItem(menuItem)
                    }
                }

                setTimeout(check, 150)

                // if (!menuItem.classList.contains('active')) {
                //     // open the meganav item.
                //     menuItem.classList.add('active')
                //     console.log('step 1...')
                // }
            })
        })

        this._menuItems.forEach((menuItem) => {
            menuItem.addEventListener('mouseenter', () => {
                this._dropdownIsActive = true
            })
        })

        this._menuItems.forEach((menuItem) => {
            menuItem.addEventListener('mouseleave', () => {
                // if menu is open...
                if (menuItem.classList.contains('active') && !this._animating) {
                    // close the meganav item.
                    this._closeMenuItem(menuItem)
                }
            })
        })

        this._onImageHover()
    }

    _closeMenuItem (menuItem) {
        menuItem.classList.remove('active')
        this._dropdownIsActive = false
    }

    _onImageHover () {
        let megaNavSlider = window.slickSliders['meganav-slider']

        this._menuItemsWithImages.forEach(menuItem => {
            menuItem.addEventListener('mouseenter', () => {
                let slideNum = menuItem.dataset.collectionImage
                console.log('this._menuItemsWithImages: ' + (slideNum - 1))
                megaNavSlider.slick('slickGoTo', slideNum - 1)
            })
        })

        this._menuItemOverlays.forEach(overlay => {
            console.log('this._menuItemOverlays')
            overlay.addEventListener('mouseenter', e => {
                megaNavSlider.slick('slickGoTo', 0)
            })
        })

        this._menuItemsWithoutImages.forEach(menuItem => {
            console.log('this._menuItemsWithoutImages')
            menuItem.addEventListener('mouseenter', e => {
                megaNavSlider.slick('slickGoTo', 0)
            })
        })
    }
}

export default Meganav



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Meganav.js